import { render, staticRenderFns } from "./widgetDecoratePieChart.vue?vue&type=template&id=7bfcabd3&scoped=true"
import script from "./widgetDecoratePieChart.vue?vue&type=script&lang=js"
export * from "./widgetDecoratePieChart.vue?vue&type=script&lang=js"
import style0 from "./widgetDecoratePieChart.vue?vue&type=style&index=0&id=7bfcabd3&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bfcabd3",
  null
  
)

export default component.exports